
export default function tokenWorker() {

  self.addEventListener('message', e => { // eslint-disable-line no-restricted-globals

    if (!e || !e.data.token) throw new Error('token not defined');

    fetch(e.data.url, {
      method: 'post',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Authorization": e.data.token
        }
      })
      .then(response => response.json())
      .then(response => {
        if(!response.data || !response.data.token) {
          throw response
        }
        postMessage(JSON.stringify(response.data), e.data)
      })
      .catch(response => {
        postMessage(JSON.stringify(response))
      })
  })

}